import React, { useCallback, useState, useRef, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { getListEnteteReclamation, changeEtatEntete, changeStatusEntete, getCommentaireReclamation, fetchAllReclamation } from "../../Redux/reclamationReduce";
import jwt_decode from "jwt-decode";
import { getGrossisteSite } from "../../Redux/grossisteReduce";
import Configuration from "../../configuration";
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { getActiveStatus } from "../../Redux/statusReduce";
import { useTranslation } from 'react-multi-lang';
import Select from "react-select";
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ImprimerAvoirReclamation from "./ImprimerAvoirReclamation";

function ListReclamationRetourValider({ obj, client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  const saveTableCalled = useRef(false);
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  localStorage.removeItem("bonification");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [selectedTraiters, setSelectedTraiters] = useState([]);
  const commentaireRef = useRef(null);
  const statusRef = useRef(null);
  const referenceRef = useRef(null);
  const optionStatus = useRef(null)
  const setReference = (newValue) => {
    referenceRef.current = newValue;
  };
  const detailReference = async (qualipro) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        onConfirm={() => hideAlert()}
        cancelBtnBsStyle="danger"
      >
        <h3 className="alert-title">RÉFÉRENCE QUALIPRO</h3>
        <ul><li>{qualipro != null ? qualipro : "Aucune référence"}</li></ul>
      </SweetAlert>
    );
  };

  const modifierReference = useCallback((idClaim) => {

    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title=""
        onConfirm={() => changeEtat(idClaim)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("valider")}
        cancelBtnText={t("annuler")}
        showCancel
      >
        <h3 className="alert-title">{t("valider_claim")}</h3>
        <div>
          <Col md="12" className="pr-1">
            <Form.Group>
              <label>RÉFÉRENCE QUALIPRO</label>
              <Form.Control
                className="form-control"
                placeholder={t('write_comment')}
                onChange={(e) => setReference(e.target.value)}

              ></Form.Control>
            </Form.Group>
          </Col>
        </div>
      </SweetAlert>
    );

  }, [t]);


  const name = "listeretours";
  const currentDate = new Date();
  const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  const resultString = `${name} ${formattedDate}`;
  const fileName = resultString; // Define the file name
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

const exportToexcel = async (info) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    if (!info || info.length === 0) {
        return;
    }

    // Add headers
    const headers = Object.keys(info[0]);
    worksheet.addRow(headers);

    // Style header (optional but nice)
    worksheet.getRow(1).font = { bold: true };

    // Add rows
    info.forEach((item) => {
        worksheet.addRow(Object.values(item));
    });

    // Auto width columns
    worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
            const length = cell.value ? cell.value.toString().length : 10;
            if (length > maxLength) {
                maxLength = length;
            }
        });
        column.width = maxLength + 2;
    });

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};

  const getinfo = useCallback(
    async (rowId) => {
      var root = await dispatch(fetchAllReclamation({ client, annee, type_reclamation: 1 }));
      exportToexcel(root.payload.arrayreclamation);
    },
    [dispatch]
  );

  // For commentaire
  const setCommentaire = (newValue) => {
    commentaireRef.current = newValue;
  };
  // For commentaire
  const setOptionStatus = (newValue) => {
    optionStatus.current = newValue;
  };
  // For commentaire
  const setStatus = (newValue) => {
    statusRef.current = newValue;
  };
  const idRole = useRef(0);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  const getCommentaire = async (idReclamation) => {
    var commentaires = await dispatch(getCommentaireReclamation({ idReclamation }));
    var commentaireElements = commentaires.payload.map((element, index) => (
      (element.commentaire && element.commentaire !== "") ? (
        <li key={index}>
          <strong>{element.users.nom_prenom}</strong>: {element.commentaire} {new Date(element.createdAt).toISOString().split('T')[0]}
        </li>
      ) : null
    ));

    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        onConfirm={() => hideAlert()}
        cancelBtnBsStyle="danger"
      >
        <h3 className="alert-title">{t("comment")}</h3>
        <ul>{(commentaireElements.length == 1 && (commentaireElements[0] == null || commentaireElements[0] == "")) || (commentaireElements.length == 2 && (commentaireElements[0] == null || commentaireElements[0] == "") && (commentaireElements[1] == null || commentaireElements[1] == "")) ? t("aucun_comment") : commentaireElements}</ul>
      </SweetAlert>
    );
  };

  const changeEtat = useCallback(async (idClaim) => {
    hideAlert();
    if (saveTableCalled.current) return;
    saveTableCalled.current = true
    dispatch(changeEtatEntete({ idClaim, commentaire: commentaireRef.current, qualipro: referenceRef.current })).then(
      (e1) => {
        if (e1.payload === true) {
          saveTableCalled.current = false
          fectchListReclamation(idUser, client)
          notify(1, t("add_txt"));
        } else {
          saveTableCalled.current = false
          notify(2, t("erreur"));
        }
      }
    );
  }, []);

  const changeStatusUpdate = useCallback(async (idClaim) => {
    hideAlert();


    if (statusRef.current) {
      setLoader(true);
      dispatch(changeStatusEntete({ idClaim, status: statusRef.current })).then(
        (e1) => {
          setLoader(false);
          if (e1.payload === true) {
            setStatus(null);
            fectchListReclamation(idUser)
            notify(1, t("add_txt"));
          } else {
            notify(2, t("erreur"));
          }
        }
      );
    }
  }, []);



  const getStatus = useCallback(async () => {
    var type = await dispatch(getActiveStatus());
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id, label: e.nom, mail: e.mail });
    });
    setOptionStatus(arrayOption);
  }, [dispatch]);

  const changeStatus = useCallback(async (idClaim, statusOri) => {
    setAlert(
      <SweetAlert
        title=""
        style={{ display: "block", marginTop: "-100px" }}
        onConfirm={() => changeStatusUpdate(idClaim)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
        <h3 className="alert-title">{t("status")}</h3>
        <div>
          <Col md="12" className="pr-1">
            <Form.Group id="roleClass">
              <label>{t("status")}* </label>
              <Select
                placeholder={t("status")}
                className="react-select primary"
                classNamePrefix="react-select"
                onChange={(value) => {
                  setStatus(value);
                }}
                options={optionStatus.current}
              />
            </Form.Group>
          </Col>
        </div>
      </SweetAlert>
    );
  }, [statusRef.current]);

  const [grossisteSite, setGrossisteSite] = useState({});

  function handleGrossisteSite(client) {
    dispatch(getGrossisteSite({ id_site: client == Configuration.industrie2 ? 2 : 3 })).then((e) => {
      setGrossisteSite(e.payload)
    });

  }
  const columns = useMemo(
    () => [
      {
        id: "numero",
        header: "Numéro retour",
        accessorKey: "numero",
      },
      {
        id: "grossisteCode",
        header: "Code " + t("Wholesaler"),
        accessorFn: (row) => row.grossistes?.Code_client,
        Cell: ({ row }) => {
          const idGrossiste = row.original?.id_grossiste;
          return (
            <div>
              {idGrossiste && grossisteSite[idGrossiste]
                ? grossisteSite[idGrossiste]
                : "-"}
            </div>
          );
        },
      },
      {
        id: "grossisteName",
        header: t("Wholesaler"),
        accessorFn: (row) => row.grossistes?.Raison_sociale,
      },
      {
        id: "type",
        header: "Motif",
        accessorKey: "motif_description",
      }
      , {
        id: "date",
        header: t("date_claim"),
        accessorKey: "createdAt",
        Cell: ({ cell }) => {
          const date = cell.row.original.createdAt;
          return (
            <div className="block_action">
              {date
                ? new Date(date).toLocaleString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })
                : ""}
            </div>
          );
        },
      }
      ,
      {
        id: "status",
        header: t("status"),
        accessorKey: "status_reclamations.nom",
        Cell: ({ cell }) =>
          cell.row.original.etat == 0 && idRole.current === 5 && cell.row.original.type_reclamation == 2 ? (

            <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(e) => {
                changeStatus(cell.row.original.id, cell.row.original.status_reclamations);
              }}
              variant="info"
              className="  btn success"
            >
              {cell.row.original.status_reclamations.nom}

            </Button>
          ) : cell.row.original.etat == 0 && cell.row.original.type_reclamation == 2 ? (
            cell.row.original.status_reclamations.nom
          ) : cell.row.original.traiter == 0 && cell.row.original.type_reclamation == 1 ? (
            "En cours de traitement par AFC"
          ) : cell.row.original.traiter == 1 && cell.row.original.type_reclamation == 1 ? (
            cell.row.original.motif == 1 ? "En cours de traitement par CG" : "Traitée") :
            cell.row.original.traiter == 2 && cell.row.original.type_reclamation == 1 ? ("Traitée") :
              cell.row.original.traiter == -2 && cell.row.original.type_reclamation == 1 ? 'Refusé par CG' :
                'Refusé par AFC'
      },
      {
        id: "date_traitement_afc",
        header: t("date") + " traitement AFC",
        accessorKey: "date_traitement_afc",
        Cell: ({ cell }) => {
          const date = cell.row.original.date_traitement_afc;
          return (
            <div className="block_action">
              {date
                ? new Date(date).toLocaleString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })
                : ""}
            </div>
          );
        },
      },
      {
        id: "traiter_par",
        header: "Traité par",
        accessorKey: "id_afc",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.id_afc !== null
              ? cell.row.original.afcs.nom_prenom
              : ""}
          </div>
        ),
      },
      {
        id: "commentaire_afc",
        header: t("commentaire") + " AFC",
        accessorKey: "commentaire_afc",
      },
      {
        id: "traiter_par_daf",
        header: "CG",
        accessorKey: "id_daf",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.id_daf !== null
              ? cell.row.original.dafs.nom_prenom
              : ""}
          </div>
        ),
      },
      {
        id: "date_traitement_daf",
        header: t("date") + " traitement CG",
        accessorKey: "date_traitement_daf", Cell: ({ cell }) => {
          const date = cell.row.original.date_traitement_daf;
          return (
            <div className="block_action">
              {date
                ? new Date(date).toLocaleString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                })
                : ""}
            </div>
          );
        },
      },
      {
        id: "commentaire_daf",
        header: t("commentaire") + " CG",
        accessorKey: "commentaire_daf",
      },
      {
        id: "avoir",
        header: "Recap",
        accessorKey: "",
        Cell: ({ cell }) => (
          cell.row.original.traiter == 2 && cell.row.original.type_reclamation == 1 ?
            <ImprimerAvoirReclamation t={t} idReclamation={cell.row.original.id} type={1} />
            : null
        ),
      },
      {
        id: "visualization",
        header: t("visualization"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              if (cell.row.original.type_reclamation == 2) detailReclamation(cell.row.original.id);
              else if ((cell.row.original.type_reclamation == 1 && idRole.current == 5 && cell.row.original.traiter == 0) || (cell.row.original.type_reclamation == 1 && idRole.current == 11 && cell.row.original.traiter == 1)) modifierReclamation(cell.row.original.id);
              else detailReclamation(cell.row.original.id)
            }}
            className="btn btn-info"
          >
            {((cell.row.original.type_reclamation == 1 && idRole.current == 5 && cell.row.original.traiter == 0) || (cell.row.original.type_reclamation == 1 && idRole.current == 11 && cell.row.original.traiter == 1)) ? <i className="fas fa-pencil"></i> : <i className="fas fa-info"></i>}
          </Button>
        ),
      },
      {
        id: "qualipro",
        header: "RÉFÉRENCE QUALIPRO",
        accessorKey: "qualipro",
        Cell: ({ cell }) => (
          cell.row.original.motif == 3 ?
            <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(e) => {
                if (cell.row.original.qualipro == null && idRole.current == 5) modifierReference(cell.row.original.id);
                else detailReference(cell.row.original.qualipro)
              }}
              className="btn btn-info"
            >
              {cell.row.original.qualipro == null && idRole.current == 5 ? <i className="fas fa-pencil"></i> : <i className="fas fa-eye"></i>}
            </Button> : null
        ),
      },
      (obj.user.id_role == 11 || obj.user.id_role == 10)
      && {
        id: "Etat Avoir",
        header: "État Avoir",
        accessorKey: "envoie",
        Cell: ({ cell }) => (
          <div className="block_action">
            {cell.row.original.traiter == 2 && cell.row.original.type_reclamation == 1 ? cell.row.original.envoie == 0
              ? "Non envoyé"
              : "Envoyé" : "-"}
          </div>
        ),
      }
      ,

      {
        id: "file_avoir",
        header: "Avoir",
        accessorKey: "file_avoir",
        Cell: ({ cell }) => (
          cell.row.original.traiter == 2 && cell.row.original.type_reclamation == 1 ?
            <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(e) => {
                detailAvoirReclamation(cell.row.original.id);

              }}
              className="btn btn-info"
            >
              Avoir
            </Button>
            : null
        ),
      },
    ].filter(Boolean),
    [t, grossisteSite, idRole]// ⚠️ dépendances
  );

  function ListTable({ list, loader }) {
    const tableInstanceRef = useRef();

    // Filtrer les lignes selon selectedTraiters
    const filteredData = selectedTraiters.length === 0
      ? list
      : list.filter((row) => selectedTraiters.includes(row.traiter));

    return (
      <>
        {
          idRole.current !== 12 &&
          <div style={{ maxWidth: 300, marginBottom: 10 }}>
            <label><b>Filtrer par état de traitement :</b></label>
            <Select
              isMulti
              placeholder="Tous les états"
              value={selectedTraiters.map((val) => ({
                value: val,
                label:
                  val === 0 ? "En cours de traitement AFC" :
                    val === 1 ? "En cours de traitement CG" :
                      val === 2 ? "Traitée" :
                        val === -2 ? "Refusée par CG" :
                          val === -1 ? "Refusée par AFC" : "Autre",
              }))}
              onChange={(selected) => {
                const values = selected.map((s) => s.value);
                setSelectedTraiters(values);
              }}
              options={[
                { value: 0, label: "En cours de traitement AFC" },
                { value: 1, label: "En cours de traitement CG" },
                { value: 2, label: "Traitée" },
                { value: -2, label: "Refusée par CG" },
                { value: -1, label: "Refusée par AFC" },
              ]}
              menuPortalTarget={document.body} // ← Force le menu à se rendre dans <body>
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ← S'assure qu'il passe devant
              }}
            />

          </div>
        }

        {/* Tableau */}
        <MaterialReactTable
          tableInstanceRef={tableInstanceRef}
          state={{ isLoading: loader }}
          columns={columns}
          data={filteredData}
          enableColumnActions={true}
          enableColumnFilters={true}
          enablePagination={true}
          enableSorting={true}
          enableBottomToolbar={true}
          enableTopToolbar={true}
          muiTableBodyRowProps={{ hover: false }}
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              size: 10,
            },
            'mrt-row-expand': {
              size: 10,
            },
          }}
          enableColumnFilterModes
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
          }}
          muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          filterFns={{
            myCustomFilterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
            },
          }}
          globalFilterFn="myCustomFilterFn"
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
        />
      </>
    );
  }


  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const hideAlert = () => {
    setAlert(null);
  };



  const fectchListReclamation = useCallback(
    async (idUser, client, id_role) => {
      setLoader(true);

      // Fetch all reclamations
      const list = await dispatch(
        getListEnteteReclamation({
          id_user: idUser,
          etat: 2,
          annee,
          client,
          type_reclamation: 1,
        })
      );

      let res = list.payload;

      // Filter only "traiter=2" if role is 12
      if (idRole.current === 12) {
        res = res.filter(item => item.traiter === 2);
      }

      setData(res);
      setLoader(false);
    },
    [dispatch, annee]
  );



  function detailReclamation(id) {
    navigate.push(client + "/detailsReclamationAll/" + id);
  }

  function detailAvoirReclamation(id) {
    navigate.push(client + "/detailsAvoirReclamation/" + id);
  }

  function modifierReclamation(id) {
    navigate.push(client + "/modifierReclamationAll/" + id);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        fectchListReclamation(idUser, client);
        handleGrossisteSite(client)
        getStatus()
      }
    };
    fetchData();
    console.log("ici")
  }, [idRole.current]);

  return (
    <>

      <Container fluid>
        {alert}
        <ToastContainer />
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Mes retours
                  <Button
                    className="btn-wd  btn-export mr-1 float-right"
                    type="button"
                    onClick={() => {
                      getinfo()
                    }}
                    style={{ cursor: "pointer", fontSize: 14 }}
                  >
                    Exporter retour
                  </Button>


                </Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListReclamationRetourValider;
